import '../../modules/mode-components';

import * as angular from 'angular';

const PADDING = 20;

const autoHeightDirective = function ($window) {
  return {
    link: function (scope: angular.IScope, element) {
      const $childElement = element.children().first();

      const resize = function () {
        if (
          element.offset().top + element.height() + PADDING > $window.innerHeight ||
          element.hasClass('auto-height-resize')
        ) {
          element.addClass('auto-height-resize');
          const newHeight = $window.innerHeight - element.offset().top - PADDING;

          if (newHeight > $childElement.height()) {
            element.height('auto');
            element.removeClass('auto-height-resize');
          } else {
            element.height(newHeight);
          }
        }
      };

      angular.element($window).on('resize', resize);

      scope.$on('$destroy', function () {
        angular.element($window).off('resize', resize);
      });
    },
  };
};

autoHeightDirective.$inject = ['$window'];

angular.module('mode.components').directive('autoHeight', autoHeightDirective);
